import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'examkrackers-components'
import styled from 'styled-components'

interface AiWidgetEmptyStateProps {
  redirectToAiEvaluation: () => void
}
const AiWidgetEmptyState = ({
  redirectToAiEvaluation
}: AiWidgetEmptyStateProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <MainContainer>
      <MainExamBar>
        <SectionTitle>{t('dashboard.aiWidget.emptyState.title')}</SectionTitle>

        <Button color='secondary' onClick={redirectToAiEvaluation}>
          {t('dashboard.aiWidget.button')}
        </Button>
        <SubTitle>
          {t('dashboard.aiWidget.emptyState.subTitlePartOne')}
        </SubTitle>
        <SubTitle>
          {t('dashboard.aiWidget.emptyState.subTitlePartTwo')}
        </SubTitle>
      </MainExamBar>
    </MainContainer>
  )
}

export default AiWidgetEmptyState

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 185px;
  padding: 8px 10px;
  margin-bottom: 16px;
  gap: 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.backgrounds.main};
  box-shadow: ${({ theme }) => theme.shadows.mainShadow};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15px;
`

const MainExamBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  width: 185px;
`

const SectionTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  width: 600px;
  text-align: center;
  margin-bottom: 15px;
`

const SubTitle = styled.div`
  width: 600px;

  font-size: 10px;
  font-weight: 400;
  line-height: 11.5px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  &:first-of-type {
    margin-top: 15px;
  }
  &:last-of-type {
    margin-top: 10px;
  }
`
